
  (function () {
    var carousel = document.getElementById('testimonialsCarousel-template--27736504139934__ss_testimonials_grid_KbX3md');
    if (!carousel) return;

    if (!('scrollBehavior' in document.documentElement.style)) {
      carousel.style.scrollBehavior = 'auto';
    }

    var items = carousel.querySelectorAll('.testimonial-item');

    function getDistanceFromCenter(item) {
      var carouselRect = carousel.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var carouselCenter = carouselRect.left + carouselRect.width / 2;
      var itemCenter = itemRect.left + itemRect.width / 2;
      return Math.abs(carouselCenter - itemCenter);
    }

    function updateActiveItem() {
      if (window.innerWidth > 768) {
        items.forEach(function (item) { item.classList.remove('active'); });
        return;
      }
      var closestItem = null;
      var minDistance = Infinity;
      items.forEach(function (item) {
        var distance = getDistanceFromCenter(item);
        if (distance < minDistance) { minDistance = distance; closestItem = item; }
      });
      items.forEach(function (item) {
        item.classList.toggle('active', item === closestItem);
      });
    }

    carousel.addEventListener('scroll', updateActiveItem);
    carousel.addEventListener('scrollend', updateActiveItem);
    window.addEventListener('resize', updateActiveItem);
    document.addEventListener('shopify:section:load', updateActiveItem);
    setTimeout(updateActiveItem, 100);
  })();


(function(){var n=14,x=31,el=document.getElementById('flotty-vc');if(!el)return;function r(){return Math.floor(Math.random()*(x-n+1))+n}function u(){var c=parseInt(el.textContent)||r(),d=Math.random()<.5?-1:1;if(Math.random()<.3)d*=2;c+=d;if(c<n)c=n+1;if(c>x)c=x-1;el.textContent=c}el.textContent=r();(function s(){setTimeout(function(){u();s()},8e3+Math.floor(Math.random()*7e3))})()})();


  function togglePlayPause(videoElement) {
    if (videoElement.paused) {
      const videos = document.querySelectorAll('.grid-video');
      videos.forEach(video => {
        if (video !== videoElement) {
          video.pause();
          video.muted = true;
        }
      });
      videoElement.muted = false;
      videoElement.play();
    } else {
      videoElement.pause();
    }
  }

  function scrollCarousel(direction) {
    const carousel = document.getElementById('videoCarousel');
    const scrollAmount = 300;
    if (direction === 1) {
      carousel.appendChild(carousel.firstElementChild);
    } else {
      carousel.insertBefore(carousel.lastElementChild, carousel.firstElementChild);
    }
  }


  (function () {
    var wrap = document.getElementById('videoMarqueeWrap-template--27736504139934__video_marquee_social_proof_QiFi7R');
    var track = document.getElementById('videoMarqueeTrack-template--27736504139934__video_marquee_social_proof_QiFi7R');
    if (!wrap || !track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.flotty-vm-item'));
    var setSize = items.length / 3; // number of unique videos
    if (setSize < 1) return;

    var popDuration = 5 * 1000;
    var slideDuration = 600;

    var current = Math.floor(setSize); // start in the middle copy
    var phase = 'holding'; // 'sliding' while moving to center, 'holding' while enlarged
    var phaseStart = Date.now();
    var paused = false;
    var lockedByClick = false; // true while the user has deliberately selected a video to watch fully

    function itemGeometry(index) {
      var item = items[index];
      return { left: item.offsetLeft, width: item.offsetWidth };
    }

    function centerOn(index, animate) {
      var wrapWidth = wrap.getBoundingClientRect().width;
      var geo = itemGeometry(index);
      var targetCenter = geo.left + geo.width / 2;
      var offset = (wrapWidth / 2) - targetCenter;
      track.style.transition = animate
        ? 'transform ' + slideDuration + 'ms cubic-bezier(0.22, 0.8, 0.2, 1)'
        : 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
    }

    function goTo(index, animate) {
      items.forEach(function (it) { it.classList.remove('flotty-vm-center'); });
      current = index;
      centerOn(current, animate);
      applyWallTilt();
      phase = 'sliding';
      phaseStart = Date.now();
    }

    // Videos to the left of the centered one tilt one way, videos to the
    // right tilt the other way — this is recalculated every time the
    // centered video changes, based on their real position, not a fixed
    // alternating pattern.
    function applyWallTilt() {
      items.forEach(function (it, idx) {
        it.classList.remove('flotty-vm-left', 'flotty-vm-right');
        if (idx < current) {
          it.classList.add('flotty-vm-left');
        } else if (idx > current) {
          it.classList.add('flotty-vm-right');
        }
      });
    }

    // Single robust poll loop — no chained/racy timeouts.
    // "paused" only blocks moving on to the NEXT video; the slide-in and
    // zoom-in of whichever video is currently targeted always completes.
    function tick() {
      var elapsed = Date.now() - phaseStart;

      if (phase === 'sliding' && elapsed >= slideDuration) {
        items[current].classList.add('flotty-vm-center');
        // re-center now that this item's real box just grew taller/wider
        centerOn(current, true);
        phase = 'holding';
        phaseStart = Date.now();
        return;
      }

      if (phase === 'holding' && !paused && elapsed >= popDuration) {
        var next = current + 1;
        if (next >= setSize * 2) {
          next -= Math.floor(setSize);
        }
        goTo(next, true);
      }
    }

    setInterval(tick, 100);
    centerOn(current, false);
    items[current].classList.add('flotty-vm-center');
    applyWallTilt();

    // Manual swipe/drag: the person can drag the row left or right with a
    // finger (or mouse) to browse freely, then let go — whichever video is
    // closest to the center at that moment snaps into place, locks, and
    // plays in full, exactly like tapping it directly.
    var dragging = false;
    var dragIntentDecided = false;
    var dragIsHorizontal = false;
    var startX = 0;
    var startY = 0;
    var startOffset = 0;

    function currentOffsetPx() {
      var t = track.style.transform;
      var match = /translateX\(([-\d.]+)px\)/.exec(t);
      return match ? parseFloat(match[1]) : 0;
    }

    function nearestIndexToCenter() {
      var wrapCenter = wrap.getBoundingClientRect().left + wrap.getBoundingClientRect().width / 2;
      var best = current;
      var bestDist = Infinity;
      items.forEach(function (it, idx) {
        var r = it.getBoundingClientRect();
        var itemCenter = r.left + r.width / 2;
        var dist = Math.abs(itemCenter - wrapCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = idx;
        }
      });
      return best;
    }

    wrap.addEventListener('pointerdown', function (e) {
      dragging = true;
      dragIntentDecided = false;
      dragIsHorizontal = false;
      startX = e.clientX;
      startY = e.clientY;
      startOffset = currentOffsetPx();
      track.style.transition = 'none';
    });

    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!dragIntentDecided) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          dragIntentDecided = true;
          dragIsHorizontal = Math.abs(dx) > Math.abs(dy);
          if (dragIsHorizontal) {
            paused = true;
            lockedByClick = false;
          }
        }
      }

      if (dragIsHorizontal) {
        e.preventDefault(); // only block page scroll once we know it's a horizontal swipe
        track.style.transform = 'translateX(' + (startOffset + dx) + 'px)';
      }
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      if (dragIsHorizontal) {
        var target = nearestIndexToCenter();
        lockedByClick = true;
        paused = true;
        goTo(target, true);
      }
    }

    wrap.addEventListener('pointerup', endDrag);
    wrap.addEventListener('pointercancel', endDrag);
    wrap.addEventListener('pointerleave', function () {
      if (dragging) endDrag();
    });

    // Hovering (desktop) previews a video briefly. Clicking / tapping LOCKS
    // it fully centered and enlarged — the auto-cycle stops completely so
    // the person can watch the whole video, while every other video keeps
    // playing quietly in the background at its normal small size. Clicking
    // the same video again, or clicking anywhere outside the carousel,
    // releases the lock and resumes the normal cycling.
    items.forEach(function (item, index) {
      item.style.cursor = 'pointer';

      item.addEventListener('mouseenter', function () {
        if (phase === 'sliding' || lockedByClick) return;
        paused = true;
        if (index !== current) {
          goTo(index, true);
        } else {
          phase = 'holding';
        }
      });

      item.addEventListener('mouseleave', function () {
        if (lockedByClick) return;
        paused = false;
        phaseStart = Date.now();
      });

      item.addEventListener('click', function (e) {
        e.stopPropagation();
        if (phase === 'sliding') return;

        if (lockedByClick && index === current) {
          // clicking the already-locked video again releases it
          lockedByClick = false;
          paused = false;
          phaseStart = Date.now();
          return;
        }

        lockedByClick = true;
        paused = true;
        if (index !== current) {
          goTo(index, true);
        } else {
          phase = 'holding';
        }
      });
    });

    // Clicking anywhere outside the carousel also releases a locked video.
    document.addEventListener('click', function () {
      if (lockedByClick) {
        lockedByClick = false;
        paused = false;
        phaseStart = Date.now();
      }
    });

    // Recalculate position on resize (orientation change, window resize)
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        centerOn(current, false);
      }, 150);
    });

    var videos = track.querySelectorAll('video');
    var visibleItems = new Set();

    function playAllVideos() {
      // Only (re)play items currently known to be near the viewport —
      // trying to play everything at once is what overloads iOS Safari's
      // limited number of simultaneous video decoders in the first place.
      items.forEach(function (item) {
        if (!visibleItems.has(item)) return;
        var v = item.querySelector('video');
        if (!v) return;
        v.muted = true;
        v.setAttribute('playsinline', '');
        var playPromise = v.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {});
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) {
            visibleItems.add(entry.target);
            v.muted = true;
            v.setAttribute('playsinline', '');
            var p = v.play();
            if (p !== undefined) p.catch(function () {});
          } else {
            visibleItems.delete(entry.target);
            v.pause();
          }
        });
      }, { root: wrap, rootMargin: '250px', threshold: 0.01 });

      items.forEach(function (item) { observer.observe(item); });
    } else {
      // Older browser fallback: just attempt to play everything.
      videos.forEach(function (v) { visibleItems.add(v.closest('.flotty-vm-item')); });
      playAllVideos();
    }

    // iOS Safari sometimes silently blocks the initial autoplay attempt.
    // The very first tap/scroll anywhere on the page is a real "user gesture",
    // so we use it to retry once, which reliably unlocks playback.
    var retried = false;
    function retryOnFirstInteraction() {
      if (retried) return;
      retried = true;
      playAllVideos();
      document.removeEventListener('touchstart', retryOnFirstInteraction);
      document.removeEventListener('click', retryOnFirstInteraction);
    }
    document.addEventListener('touchstart', retryOnFirstInteraction, { passive: true });
    document.addEventListener('click', retryOnFirstInteraction);
  })();


    
      function checkBtnVisibility() {
        const scrollToTopBtn = document.querySelector('.scroll-to-top-btn');
        if (scrollToTopBtn) {
          if (window.scrollY > 400) {
            scrollToTopBtn.style.display = '';
          } else {
            scrollToTopBtn.style.display = 'none';
          }
        }
      }
      checkBtnVisibility()
    
      window.addEventListener('scroll', checkBtnVisibility)
    
  
    function handleScrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  